import { render, staticRenderFns } from "./RsvpModal.vue?vue&type=template&id=dd32a4e8&scoped=true"
import script from "./RsvpModal.vue?vue&type=script&lang=js"
export * from "./RsvpModal.vue?vue&type=script&lang=js"
import style0 from "./RsvpModal.vue?vue&type=style&index=0&id=dd32a4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd32a4e8",
  null
  
)

export default component.exports